'use client';

import {Storage} from '@utils/sessionstorage';

type SO = {label: string; value: string};

const RECENT_SEARCH_ITEMS = 'RECENT_SEARCH_ITEMS';
export const RECENT_SEARCH_MAX_COUNT = 2;

export function syncWithStorage(selectedOptions: SO[]) {
  const previouslySearchedOptions =
    Storage.get<Array<SO>>(RECENT_SEARCH_ITEMS) ?? [];
  const previouslySearchedOptionIds = previouslySearchedOptions.map(
    (o) => o.value
  );
  const newSearchedOptions = selectedOptions.filter(
    (o) => !previouslySearchedOptionIds.includes(o.value)
  );
  Storage.set<Array<SO>>(
    RECENT_SEARCH_ITEMS,
    [...newSearchedOptions, ...previouslySearchedOptions].slice(
      0,
      RECENT_SEARCH_MAX_COUNT
    )
  );
}

export function getSearchHistoryValues() {
  const previouslySearchedOptions =
    Storage.get<Array<SO>>(RECENT_SEARCH_ITEMS) ?? [];
  return previouslySearchedOptions.map((o) => o.value);
}
